export function getWorkspaceKeywordsPath(workspaceId: string, connectorId: string) {
  return `${getWorkspacePath(workspaceId)}/connectors/${connectorId}/keywords`;
}

export function getWorkspaceTagsPath(workspaceId: string, connectorId: string) {
  return `${getWorkspacePath(workspaceId)}/connectors/${connectorId}/tags`;
}

export function getWorkspacePath(workspaceId: string) {
  return `workspaces/${workspaceId}`;
}

export function getWorkspacePermissionsPath(workspaceId: string) {
  return `${getWorkspacePath(workspaceId)}/permissions`;
}

export function getWorkspaceUserPermissionsPath(workspaceId: string, userId: string) {
  return `${getWorkspacePermissionsPath(workspaceId)}/${userId}`;
}

export function getWorkspaceInvitationsPath(workspaceId: string) {
  return `${getWorkspacePath(workspaceId)}/invitations`;
}

export function getWorkspaceLinksPath(workspaceId: string) {
  return `${getWorkspacePath(workspaceId)}/links`;
}

export function getWorkspaceTaxonomyPath(workspaceId: string) {
  return `${getWorkspacePath(workspaceId)}/taxonomy`;
}

export function getWorkspaceConnectorsPath(workspaceId: string) {
  return `${getWorkspacePath(workspaceId)}/connectors`;
}

export function getOrganizationPermissionsPath(organizationId: string) {
  return `organizations/${organizationId}/organization_permissions`;
}

export function getOrganizationInvitationsPath(organizationId: string) {
  return `organizations/${organizationId}/organization_invitations`;
}
